/**
 * 事件绑定工具模块
 * 提供跨浏览器的事件监听器绑定和移除功能
 * 
 * @module common/utils/events
 * @author wei<innereyecw@gmail.com>
 * @version 5.0.0
 */
(function (global) {
  "use strict";

  // 确保命名空间存在
  if (!global.watashi) {
    global.watashi = {};
  }
  if (!global.watashi.common) {
    global.watashi.common = {};
  }

  const common = global.watashi.common;

  /**
   * 绑定事件监听器（兼容旧版浏览器）
   * @param {Element} elem - DOM元素
   * @param {string} type - 事件类型
   * @param {Function} handler - 事件处理函数
   * @param {boolean} [useCapture=false] - 是否使用捕获阶段
   * 
   * @example
   * watashi.common.registerEvent(button, 'click', handleClick);
   */
  common.registerEvent = (function () {
    if (window.addEventListener) {
      return function (elem, type, handler, useCapture) {
        elem.addEventListener(type, handler, useCapture);
      };
    } else if (window.attachEvent) {
      return function (elem, type, handler) {
        elem.attachEvent("on" + type, function () {
          handler.call(elem, window.event);
        });
      };
    } else {
      return function (elem, type, handler) {
        elem["on" + type] = handler;
      };
    }
  })();

  /**
   * 移除事件监听器（兼容旧版浏览器）
   * @param {Element} elem - DOM元素
   * @param {string} type - 事件类型
   * @param {Function} handler - 事件处理函数
   * @param {boolean} [useCapture=false] - 是否使用捕获阶段
   * 
   * @example
   * watashi.common.unregisterEvent(button, 'click', handleClick);
   */
  common.unregisterEvent = (function () {
    if (window.removeEventListener) {
      return function (elem, type, handler, useCapture) {
        elem.removeEventListener(type, handler, useCapture);
      };
    } else if (window.detachEvent) {
      return function (elem, type, handler) {
        elem.detachEvent("on" + type, handler);
      };
    } else {
      return function (elem, type, handler) {
        elem["on" + type] = null;
      };
    }
  })();

})(typeof window !== "undefined" ? window : this);
